// frontend/src/utils/watchUtils.js

export function extractIntervals(logs) {
  if (!logs || !Array.isArray(logs) || logs.length === 0) {
    return [];
  }

  const processedLogs = logs
    .map(log => {
      if (typeof log !== 'object' || log === null) return null;
      
      let timestampDate = null;
      if (log.timestamp) {
        if (log.timestamp instanceof Date && !isNaN(log.timestamp.getTime())) {
          timestampDate = log.timestamp;
        } else if (typeof log.timestamp === 'string') {
          const d = new Date(log.timestamp.endsWith('Z') ? log.timestamp : log.timestamp + 'Z');
          if (!isNaN(d.getTime())) {
            timestampDate = d;
          }
        }
      }
      
      let playedSecondsNum = 0;
      if (log.played_seconds !== null && log.played_seconds !== undefined) {
        const parsed = parseFloat(log.played_seconds);
        if (!isNaN(parsed)) {
          playedSecondsNum = parsed;
        }
      }

      if (!timestampDate) return null; 

      return {
        ...log,
        timestamp: timestampDate,
        played_seconds: playedSecondsNum
      };
    })
    .filter(log => log !== null);

  if (processedLogs.length === 0) return [];

  const sorted = processedLogs.sort(
    (a, b) => a.timestamp.getTime() - b.timestamp.getTime()
  );

  const intervals = [];
  let currentStartPos = null;
  let currentStartTs = null;

  for (let i = 0; i < sorted.length; i++) {
    const e = sorted[i];
    const pos = e.played_seconds;
    const eventTs = e.timestamp;
    const eventType = e.event_type;

    if (eventType === "start" || eventType === "resume") {
      currentStartPos = pos;
      currentStartTs = eventTs;
      continue;
    }

    if (currentStartPos === null || currentStartTs === null) {
      continue;
    }

    if (eventType === "seek" || eventType === "pause" || eventType === "end") {
      const dtSec = (eventTs.getTime() - currentStartTs.getTime()) / 1000;
      const dp = pos - currentStartPos;

      if (eventType === "pause") {
        const nextEvent = sorted[i + 1];
        if (nextEvent && nextEvent.event_type === "seek" &&
            nextEvent.timestamp instanceof Date &&
            ((nextEvent.timestamp.getTime() - eventTs.getTime()) / 1000 < 2) ) {
          currentStartPos = null;
          currentStartTs = null;
          continue;
        }
      }
      
      if (dp > 0 && (dp <= dtSec + 1.5 || ( (eventType === "end" || eventType === "pause") && dtSec < 5 && dp <=60) )) { 
        intervals.push({
          name: `区間 ${intervals.length + 1}`,
          offset: currentStartPos,
          duration: dp,
        });
      }
      currentStartPos = null;
      currentStartTs = null;
    }
  }
  return intervals;
}

export function computeTotalWatchTime(logs) {
  if (!logs || !Array.isArray(logs) || logs.length === 0) {
    return 0;
  }
  const validIntervals = extractIntervals(logs);
  let sumOfDurations = 0;
  for (const seg of validIntervals) {
    if (seg && typeof seg.duration === 'number' && !isNaN(seg.duration)) {
      sumOfDurations += seg.duration;
    }
  }
  return sumOfDurations;
}